import React from 'react'
import { observer } from 'mobx-react-lite'

import { ListItem, ListItemText } from '@material-ui/core'

import { DropdownButton } from './DropdownButton'
import { ExportFileKind } from './ExportToExcelButton'

import { useBoolState } from '../hooks/commonHooks'
import { useStoreRoute } from '../hooks/routeHooks'
import { useApi, useStore } from '../hooks/storeHook'
import { useMyProductColumns } from '../hooks/myProductHooks'
import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

import { required } from '../common/objectUtils'
import { buildExcelExportFilename } from '../common/stringUtility'

import { MyProductColumnId, selectColumnId, syncErrorsColumnId } from '../types/myProductColumnIds'

const excludedColumnIds: string[] =
  [syncErrorsColumnId, 'SyncLogs', selectColumnId] satisfies MyProductColumnId[]

export const ExportMyProductsButton =
  observer(() => {
    const menuClasses = useDefaultMenuItemStyles()

    const api = useApi()
    const {productStore} = useStore()
    const storeRoute = useStoreRoute()
    const myProductColumns = useMyProductColumns()

    const [isExporting, setExporting, setExported] = useBoolState()

    const onExport =
      async (setClosed: VoidFunction) => {
        setClosed()

        if (isExporting) {
          return
        }

        setExporting()

        try {
          const exportColumnIds = myProductColumns.visible
                                                  .map(column => column.id)
                                                  .filter(columnId => !excludedColumnIds.includes(columnId))

          const exportedBlob = await api.product.exportMyProductsToExcel({
            ...productStore.myProducts.getExportOptions(),
            integrationType: required(storeRoute).integration,
            accountId: required(storeRoute).accountId,
            productsStateTab: productStore.myStateTab,
            columnIds: exportColumnIds
          })

          api.downloadBlob(exportedBlob, buildExcelExportFilename(undefined, ExportFileKind.Products))
        } finally {
          setExported()
        }
      }

    return (
      <DropdownButton text={isExporting ? 'Экспортируем...' : 'Экспорт'} popupWidth={120} disabled={isExporting}>
        {
          buttonProps =>
            <ListItem
              button
              className={menuClasses.menuItem}
              onClick={() => onExport(buttonProps.setClosed)}
            >
              <ListItemText primary="В файл .xlsx"/>
            </ListItem>
        }
      </DropdownButton>
    )
  })